import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import { Stack, Switch } from "@mui/material";
import { useUserPreferences } from "../../../hooks/Preferences/useUserPreferences";

export default function ThemeToggle() {
  const { preferences, updatePreferences } = useUserPreferences();

  const handleThemeToggle = () => {
    updatePreferences({ ...preferences, theme: preferences?.theme === "dark" ? "light" : "dark" });
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, py: 0.8 }}
    >
      <LightModeRoundedIcon fontSize="small" sx={{ color: "text.secondary" }} />
      <Switch checked={preferences?.theme === "dark"} size="small" onChange={handleThemeToggle} />
      <DarkModeRoundedIcon fontSize="small" sx={{ color: "text.secondary" }} />
    </Stack>
  );
}